"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseConfig;

var _forEach = _interopRequireDefault(require("lodash/forEach"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseConfig(commands, responseBody) {
  // for example, turn 'ads,autoupdate' into ['ads', 'autoupdate']
  var commandArray = commands.split(','); // config response is different depending on how many commands are passed in
  // handle 1 command separately from 2+ commands

  var response = {};

  if (commandArray.length === 1) {
    // eslint-disable-next-line prefer-destructuring
    response[commandArray[0]] = responseBody.body[0];
  } else if (commandArray.length > 1) {
    (0, _forEach.default)(responseBody.body, function (obj) {
      // eslint-disable-next-line prefer-destructuring
      response[obj.key] = obj.children[0];
    });
  }

  return response;
}